import React, { ReactChildren } from 'react';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
  WithStyles,
  createStyles,
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';

const styles = (theme: Theme) => createStyles({
  default: {
    backgroundColor: theme.palette.grey[300],
    padding: 6,
    '&:hover': {
      backgroundColor: theme.palette.grey[300],
    }
  },
  flat: {
    backgroundColor: theme.palette.common.white,
    border: '1px solid rgb(226, 226, 226)',
    padding: 10,
    '&:hover': {
      backgroundColor: theme.palette.common.white,
    },
  },
  withoutBorder: {
    backgroundColor: 'transparent',
    padding: '4px 0',
    '&:hover': {
      backgroundColor: theme.palette.common.white,
    },
  },
  bordered: {
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.grey[200]}`,
    padding: 6,
    '&:hover': {
      backgroundColor: theme.palette.common.white,
    }
  },
  transparent: {
    backgroundColor: 'transparent',
    padding: 6,
    '&:hover': {
      backgroundColor: theme.palette.grey[300],
    },
  },
  withoutBorderCloseIcon: {
    backgroundColor: 'transparent',
    border: '0px solid transparent', 
    padding: 8,
    '&:hover': {
      backgroundColor: theme.palette.common.white,
    },
    '& svg':{
      fontSize: 30
    }
  }
});

interface MyPATIconButtonProps extends WithStyles<typeof styles> {
  buttonVariant: string,
  children: ReactChildren,
}

const MyPATIconButton = (props: MyPATIconButtonProps) => {
  const {
    classes,
    buttonVariant = 'default',
    children,
    ...iconButtonProps
  } = props;

  let buttonClassName = classes.default;
  if (_.isEqual(buttonVariant, 'flat')) {
    buttonClassName = classes.flat;
  }
  if (_.isEqual(buttonVariant, 'transparent')) {
    buttonClassName = classes.transparent;
  }
  if (_.isEqual(buttonVariant, 'bordered')) {
    buttonClassName = classes.bordered;
  }
  if (_.isEqual(buttonVariant, 'withoutBorder')) {
    buttonClassName = classes.withoutBorder;
  }

  if (_.isEqual(buttonVariant, 'withoutBorderCloseIcon')) {
    buttonClassName = classes.withoutBorderCloseIcon;
  }

  if (_.isEqual(buttonVariant, 'withoutBorderCloseIcon')) {
    buttonClassName = classes.withoutBorderCloseIcon;
  }

  return (
    <IconButton classes={{ root: buttonClassName }} {...iconButtonProps}>
      {children}
    </IconButton>
  );
};

export default withStyles(styles)(MyPATIconButton);